import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { createCardExport } from '@shared/api/mutations/cards';

interface CardExportResponse {
  isLoading: boolean;
  error?: string;
  url?: string;
}

interface CardExport {
  createCardExport(cardId: string): void;
  response: CardExportResponse;
}

export function useCardExport(): CardExport {
  const [create, { loading, data, error }] = useMutation<
    MBAPI.CreateCardExportMutation,
    MBAPI.CreateCardExportMutationVariables
  >(createCardExport);

  const createExport = useCallback(
    (cardId: string) => {
      create({
        variables: {
          input: {
            id: cardId,
            format: 'PDF',
          },
        },
      });
    },
    [create],
  );

  return {
    createCardExport: createExport,
    response: {
      isLoading: loading,
      error: error?.message,
      url: data?.createCardExport?.url ?? undefined,
    },
  };
}
